import { BaseModel } from './base.model';
import { Expose } from 'class-transformer';

export class CredentialModel extends BaseModel {
  @Expose()
  id!: number;

  @Expose()
  username!: string;
}
